import * as React from "react";
import { MobxComponent } from "../../../mobx/components/index";
import { Switch, TopNav } from "@lib/components";
import { LayoutDashboardComponents } from "./layout.c";
import { inject, observer } from "mobx-react";
import { Tooltip } from "@lib/components";
import { FaLifeRing, FaPowerOff, FaRocket } from "react-icons/fa";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose, IconBack, IconStore, IconLandingPage, IconStaff, IconDevelopers, IconDocument, IconRoadmap, IconLogout, IconDashboard, IconCustomers, IconHamburger, IconPlus, IconMoreOptions, IconPowerOff } from "../../components/v2/icons";
import { SidebarLogoWrapper, HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper, HeaderMobileMenuContainer, HeaderMobileMenuUpperWrapper, HeaderMobileMenuTitleWrapper, HeaderMobileTitle, HeaderMobileMenuWrapper, HeaderMobile, HeaderMobileTitleWrapper, HeaderV2LeftContainer, HeaderV2MenuGroup, HeaderV2MenuLabel, HeaderV2RightContainer, HeaderV2MenuItems, HeaderV2 } from "../../components/v2/layout.c";
import { QuickSettings } from "../../components/v2/quicksettings";
import { SidebarAPIComponent } from "./views/api/sidebar-api";
import { SettingsHeader, SettingsHeaderTextBreadcrumbs, SettingsHeaderTextContainer, SettingsHeaderTextTitle, SettingsHeaderTextWrapper } from "../restaurant/views/settings-v2";

interface Props extends WithTranslation {
	children: React.ReactNode;
}
interface State {
	quickSettings: boolean;
	isMobile: boolean;
	activeMobileMenu: boolean;
	createApiMobile: boolean;
	toggleLocalize: boolean;
}

@inject("store") @observer
class LayoutDashboardClass extends MobxComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			quickSettings: false,
			isMobile: false,
			activeMobileMenu: false,
			createApiMobile: false,
			toggleLocalize: false
		};
	}

	componentDidMount() {
		var _self = this;
		this.setState({
			isMobile: window.innerWidth < 768
		});

		window.addEventListener('resize', function() {
			if(window.innerWidth < 768) {
				_self.setState({
					isMobile: true
				})
			} else {
				_self.setState({
					isMobile: false
				})
			}
		})

		const { store } = this.injected;
		const { organisation } = store;
		//@ts-ignore
        if(document && Localize && Localize.loaded) {
			var lw = document.getElementById('localize-widget');
			if(lw) {
				store.setLocalizeWidget(lw);
				lw.remove();
			//@ts-ignore
				Localize.hideWidget();
				//@ts-ignore
				Localize.on("setLanguage", (data) => {
					store.setCwLang(data.to)
					localStorage.setItem('cw-lang', data.to)
				});
			}
        }
	}

	componentWillUnmount(): void {
		const { store } = this.injected;
		store.setLocalizeRef(React.createRef());
	}

	toggleQuickSettings() {
		this.setState({
			quickSettings: !this.state.quickSettings
		})
	}

	toggleMobileMenu() {
        this.setState({
            activeMobileMenu: !this.state.activeMobileMenu,
        })
    }

	getPathnameText(pathname: string){
		if(pathname === '/website') return 'Landing Page'
		if(pathname === '/staff') return 'Staff'
		if(pathname === '/developer') return 'Developers'
		if(pathname === '/organization') return 'Organization'
		
		return 'Restaurants'
	}


	
	render() {
		const { store, t } = this.injected;
		const reseller = store.reseller!;
		const pathname = store.router.s.path;
		const { trialExpiry, trialExpired, restrictions, isStaff, isMainReseller, organisation } = store;
		const { children } = this.props;
		const { logo_icon } = reseller.admin;
		const links = [];
		const { isMobile } = this.state;
		const { toggleLocalize } = this.state;

		const handleAdding = () => {
			switch(pathname){
				case '/developer':
					this.setState({createApiMobile: true})
					break;
				case '/staff':
					store.setOpenModalStaff(true)
					break;
				case '/':
					store.setOpenCreateRestaurant(true)
					break;
				default:
					break;
			}
		}

		if (
			restrictions.restaurant.create ||
			restrictions.restaurant.delete ||
			restrictions.restaurant.billing ||
			restrictions._.restaurantView
		) {
			links.push({
				text: "Restaurants",
				onClick: () => store.router.push("/"),
				active: pathname === "/",
				icon_mobile_only: <IconStore />
			});
		}

		if (restrictions.website.create || restrictions.website.edit) {
			links.push({
				text: "Landing Page",
				onClick: () => store.router.push("/website"),
				active: pathname === "/website",
				icon_mobile_only: <IconLandingPage />
			});
		}

		if (restrictions.staff.create || restrictions.staff.edit || restrictions.staff.delete) {
			links.push({
				text: "Staff",
				onClick: () => {store.router.push("/staff"); store.setRouterStaff(''); store.setOpenModalStaff(false)},
				active: pathname === "/staff",
				icon_mobile_only: <IconStaff />
			});
		}

		if (restrictions.api && (restrictions.api.create || restrictions.api.edit || restrictions.api.delete)) {
			links.push({
				text: "Developers",
				onClick: () => store.router.push("/developer"),
				active: pathname === "/developer",
				icon_mobile_only: <IconDevelopers />
			});
		}

    if (restrictions.api && (restrictions.api.create || restrictions.api.edit || restrictions.api.delete)) {
      links.push({
        text: "Organization",
        onClick: () => store.router.push("/organization"),
        active: pathname === "/organization",
		icon_mobile_only: <IconCustomers />
      });
    }
		
		return (
			<div>
				{ isMobile ?
				<>
					<HeaderMobile>
						<MenuItem
							onClick={() => this.toggleMobileMenu()}>
							<IconHamburger />
						</MenuItem> 
						<HeaderMobileTitleWrapper style={{justifyContent: 'center', flex: 1}}>
							<HeaderMobileTitle>
								{this.getPathnameText(pathname)}
							</HeaderMobileTitle>
						</HeaderMobileTitleWrapper>
						{ (pathname === "/developer" || pathname === "/staff") && (<MenuItem>
						<div onClick={handleAdding}>
						<IconPlus />
						</div>
					</MenuItem>)}

					{pathname === '/' && store.activeMobileMenu.referrer.length == 0 && 
					<>
					<MenuItem
						onClick={() => {
							store.setActiveMobileMenu('add-restaurant', 'restaurants')
	
						}}>
						<IconPlus />
					</MenuItem>
					<MenuItem
						onClick={() => store.setActiveMobileModal('more-actions')}>
						<IconMoreOptions />
					</MenuItem>
					</>}

					</HeaderMobile>
					<HeaderMobileMenuContainer  className={`${this.state.activeMobileMenu ? 'active' : ''}`}>
						<HeaderMobileMenuUpperWrapper>
							<HeaderMobileMenuTitleWrapper style={{borderBottom: '1px solid #dfdfdf'}}>
								<MenuItem
									onClick={() => this.toggleMobileMenu()}>
										<IconBack />
								</MenuItem>
								<HeaderMobileTitle>
									Menu
								</HeaderMobileTitle>
								<div></div>
							</HeaderMobileMenuTitleWrapper>
							<HeaderMobileMenuWrapper  style={{borderBottom: '1px solid #dfdfdf'}}>
								{links.map(link => (
								<MenuItem
									active = { link.active }
									onClick={() => {
										this.toggleMobileMenu()
										link.onClick()
									}}>
									{link.icon_mobile_only} {link.text}
								</MenuItem>
								))}
							</HeaderMobileMenuWrapper>
							<HeaderMobileMenuWrapper>
								<MenuItem
									onClick={() => { 
										this.toggleMobileMenu()
										store.updateView({quicksettings_active: true})
									}}>
									<IconSettings /> Settings
								</MenuItem>
								{reseller.admin.documentation_link && (
									<MenuItem
										onClick={() => window.open(reseller.admin.documentation_link, '_blank')}>
										<IconDocument /> Documentation
									</MenuItem>
								)}
								{reseller.admin.feature_request_link &&	( <MenuItem
										onClick={() => window.open(reseller.admin.feature_request_link, '_blank')}>
										<IconRoadmap /> Roadmap and Feature Requests
									</MenuItem>
								)}
								<MenuItem onClick={() => store.service.logout()}>
								<IconLogout/>
									Log out
								</MenuItem>
							</HeaderMobileMenuWrapper>
						</HeaderMobileMenuUpperWrapper>
					</HeaderMobileMenuContainer>
				</>

				: 
				organisation && organisation?.dashboard === 'v2.1' ?<>
				<HeaderV2>
					<HeaderV2LeftContainer>
						<img src={logo_icon} />
						<HeaderV2MenuGroup>
							{links.map( link => (
								<HeaderV2MenuLabel
									key={link.text}
									active={link.active}
									onClick={link.onClick}>
									{link.text}
								</HeaderV2MenuLabel>
							))}
						</HeaderV2MenuGroup>
					</HeaderV2LeftContainer>
					<HeaderV2RightContainer>
						<HeaderV2MenuItems
							onClick={() => { 
								store.updateView({quicksettings_active: true})
							}}>
								
							<Tooltip
								text="Settings"
								width={120}
								position="bottom"
								offset={5}>
							<IconSettings />
							</Tooltip>
						</HeaderV2MenuItems>
						{reseller.admin.documentation_link && (
						<HeaderV2MenuItems
							onClick={() => window.open(reseller.admin.documentation_link, '_blank')}>
								<Tooltip
									text="Documentation"
									width={120}
									position="bottom"
									offset={5}>
							<IconDocument />
							</Tooltip>
						</HeaderV2MenuItems>)}
						{reseller.admin.feature_request_link && (
						<HeaderV2MenuItems
							onClick={() => window.open(reseller.admin.feature_request_link, '_blank')}>
								<Tooltip
									text={<span className="inline-block lhp p-lr-1">Roadmap & Feature Requests</span>}
									width={120}
									position="bottom"
									offset={5}>
							<IconRoadmap />
							</Tooltip>
						</HeaderV2MenuItems>)}
						<HeaderV2MenuItems
							onClick={() => store.service.logout()}>
								<Tooltip text="Logout" width={60} position="bottom" offset={5}>
							<IconPowerOff />
							</Tooltip>
						</HeaderV2MenuItems>
					</HeaderV2RightContainer>
				</HeaderV2>
				</>
				: <TopNav.Wrapper>
					<TopNav.Content width="lg" align="space-between">

						<div className="flex-line centered">

							<TopNav.Logo className="m-r-4">
								<img src={logo_icon} />
							</TopNav.Logo>

							<TopNav.Menu
								align="left"
								items={links}
							/>

						</div>

						<div className="flex-line centered child-mr-7">
						
							<Tooltip
								text="Settings"
								width={120}
								position="bottom"
								offset={5}>
								<TopNav.Icon onClick={() => store.updateView({quicksettings_active: true})}>
									<IconSettings />
								</TopNav.Icon>
							</Tooltip>
							
							{(!trialExpired && !isStaff) && (
								<Tooltip
									width={200}
									position="bottom"
									offset={10}
									text={<p className="lhp p-1">Ensure all your restaurants have a payment method to prevent issues</p>}>
									<p className="">
										Trial ends {t("dateFromTimestamp", { value: trialExpiry })}
									</p>
								</Tooltip>
							)}
							{reseller.admin.documentation_link && (
								<Tooltip
									text="Documentation"
									width={120}
									position="bottom"
									offset={5}>
									<a href={reseller.admin.documentation_link} target="_blank">
										<TopNav.Icon>
											<FaLifeRing />
										</TopNav.Icon>
									</a>
								</Tooltip>
							)}
							{reseller.admin.feature_request_link && (
								<Tooltip
									text={<span className="inline-block lhp p-lr-1">Roadmap & Feature Requests</span>}
									width={120}
									position="bottom"
									offset={5}>
									<a href={reseller.admin.feature_request_link} target="_blank">
										<TopNav.Icon>
											<FaRocket />
										</TopNav.Icon>
									</a>
								</Tooltip>
							)}
							<Tooltip text="Logout" width={60} position="bottom" offset={5}>
								<TopNav.Icon onClick={() => store.service.logout()}>
									<FaPowerOff />
								</TopNav.Icon>
							</Tooltip>
						</div>

					</TopNav.Content>
				</TopNav.Wrapper> }

				<LayoutDashboardComponents.Content
					pathname={pathname}
					isStaffMobile={pathname === '/staff' || pathname === '/' && 
					store.organisation?.dashboard === 'v2.1'} className={(store.organisation && store.organisation.dashboard) || ''}>
					{children}
				</LayoutDashboardComponents.Content>
				{store.view.quicksettings_active  && <QuickSettings />  }
				<SidebarAPIComponent active={this.state.createApiMobile} index={-1} items={undefined} restaurants={store.restaurants.items} handleClose={() => {this.setState({createApiMobile: false})}} />
			</div>
		);
	}

}

export const LayoutDashboard = withTranslation()(LayoutDashboardClass);
